var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackChangesBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons/Action/assignment_ind_black_24dp 3")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tablet-View/Navigation/Side-nav_Help",
    transform: "translate(-19.000000, -385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(16.000000, 382.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/Action/assignment_ind_black_24dp",
    transform: "translate(1.333333, 1.333333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 29.3333335 0 29.3333335 29.3333335 0 29.3333335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3077779,6.02555558 L21.5844445,7.74888892 C23.3444446,9.52111115 24.4444445,11.9655556 24.4444445,14.6666667 C24.4444445,20.068889 20.068889,24.4444445 14.6666667,24.4444445 C9.26444449,24.4444445 4.88888891,20.068889 4.88888891,14.6666667 C4.88888891,9.68000004 8.61666671,5.57333336 13.4444445,4.97444447 L13.4444445,7.44333337 C9.97333338,8.03000004 7.33333337,11.0366667 7.33333337,14.6666667 C7.33333337,18.7122223 10.6211112,22.0000001 14.6666667,22.0000001 C18.7122223,22.0000001 22.0000001,18.7122223 22.0000001,14.6666667 C22.0000001,12.6377778 21.1811112,10.8044445 19.848889,9.48444449 L18.1255556,11.2077778 C19.0055556,12.1000001 19.5555556,13.3222223 19.5555556,14.6666667 C19.5555556,17.3677779 17.3677779,19.5555556 14.6666667,19.5555556 C11.9655556,19.5555556 9.77777782,17.3677779 9.77777782,14.6666667 C9.77777782,12.3933334 11.3422223,10.4988889 13.4444445,9.94888893 L13.4444445,12.5644445 C12.7111112,12.9922223 12.2222223,13.7622223 12.2222223,14.6666667 C12.2222223,16.0111112 13.3222223,17.1111112 14.6666667,17.1111112 C16.0111112,17.1111112 17.1111112,16.0111112 17.1111112,14.6666667 C17.1111112,13.7622223 16.6222223,12.9800001 15.888889,12.5644445 L15.888889,2.44444446 L14.6666667,2.44444446 C7.92000004,2.44444446 2.44444446,7.92000004 2.44444446,14.6666667 C2.44444446,21.4133334 7.92000004,26.888889 14.6666667,26.888889 C21.4133334,26.888889 26.888889,21.4133334 26.888889,14.6666667 C26.888889,11.2933334 25.5200001,8.23777782 23.3077779,6.02555558 Z",
    id: "Path",
    fill: "#232323",
    fillRule: "nonzero"
  }))))))));
}
export default SvgTrackChangesBlack24Dp;